import { Fragment } from 'react';

import { FieldLogo } from '../../components/index.js';

/**
 * Field dimensions:
 *  60 x 110 (yards)
 *  */
const MensFullFieldBackdrop: FC<any> = ({ fieldViewport, backgroundImage, viewOptions }) => {
    const fieldWidth = 60;
    const fieldHeight = 110;

    const topGoalY = 15;
    const bottomGoalY = 95;

    return (
        <g className="field-backdrop" style={{ padding: '1rem' }}>
            <g className="optional-lines">
                {/* Optional field lines */}
                {viewOptions.fieldLines?.GOAL ? (
                    <>
                        <line
                            x1={fieldViewport.getPixelX(0)}
                            y1={fieldViewport.getPixelY(bottomGoalY)}
                            x2={fieldViewport.getPixelX(fieldWidth)}
                            y2={fieldViewport.getPixelY(bottomGoalY)}
                        />
                        <line
                            x1={fieldViewport.getPixelX(0)}
                            y1={fieldViewport.getPixelY(topGoalY)}
                            x2={fieldViewport.getPixelX(fieldWidth)}
                            y2={fieldViewport.getPixelY(topGoalY)}
                        />
                    </>
                ) : null}

                {viewOptions.fieldLines?.FOOTBALL ? (
                    <>
                        {[5, 10, 15, 25, 30, 35, 40, 45, 50].map((yardsFromCenter) => (
                            <Fragment key={yardsFromCenter}>
                                {/* Left */}
                                <line
                                    x1={fieldViewport.getPixelX(fieldWidth / 2 - 7)}
                                    y1={fieldViewport.getPixelY(fieldHeight / 2 + yardsFromCenter)}
                                    x2={fieldViewport.getPixelX(fieldWidth / 2 - 5)}
                                    y2={fieldViewport.getPixelY(fieldHeight / 2 + yardsFromCenter)}
                                />
                                <line
                                    x1={fieldViewport.getPixelX(fieldWidth / 2 - 7)}
                                    y1={fieldViewport.getPixelY(fieldHeight / 2 - yardsFromCenter)}
                                    x2={fieldViewport.getPixelX(fieldWidth / 2 - 5)}
                                    y2={fieldViewport.getPixelY(fieldHeight / 2 - yardsFromCenter)}
                                />

                                {/* Right */}
                                <line
                                    x1={fieldViewport.getPixelX(fieldWidth / 2 + 5)}
                                    y1={fieldViewport.getPixelY(fieldHeight / 2 + yardsFromCenter)}
                                    x2={fieldViewport.getPixelX(fieldWidth / 2 + 7)}
                                    y2={fieldViewport.getPixelY(fieldHeight / 2 + yardsFromCenter)}
                                />
                                <line
                                    x1={fieldViewport.getPixelX(fieldWidth / 2 + 5)}
                                    y1={fieldViewport.getPixelY(fieldHeight / 2 - yardsFromCenter)}
                                    x2={fieldViewport.getPixelX(fieldWidth / 2 + 7)}
                                    y2={fieldViewport.getPixelY(fieldHeight / 2 - yardsFromCenter)}
                                />
                            </Fragment>
                        ))}
                    </>
                ) : null}
            </g>

            {/* Top Logos */}
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 10, y: 40 }}
                size={8}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 10, y: 40 }}
                size={8}
                rotation={-90}
            />

            {/* Bottom Logos */}
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 10, y: fieldHeight - 40 }}
                size={8}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 10, y: fieldHeight - 40 }}
                size={8}
                rotation={-90}
            />

            {/* Field Outline */}
            <rect
                x={fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth) : fieldViewport.getPixelX(0)}
                y={fieldViewport.flipped ? fieldViewport.getPixelY(fieldHeight) : fieldViewport.getPixelY(0)}
                width={fieldViewport.getPixelLength(fieldWidth)}
                height={fieldViewport.getPixelLength(fieldHeight)}
                fill="none"
            />

            {/* Top Field Lines */}
            <line
                x1={fieldViewport.getPixelX(0)}
                y1={fieldViewport.getPixelY(35)}
                x2={fieldViewport.getPixelX(fieldWidth)}
                y2={fieldViewport.getPixelY(35)}
            />

            <line
                x1={fieldViewport.getPixelX(10)}
                y1={fieldViewport.getPixelY(0)}
                x2={fieldViewport.getPixelX(10)}
                y2={fieldViewport.getPixelY(35)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 10)}
                y1={fieldViewport.getPixelY(0)}
                x2={fieldViewport.getPixelX(fieldWidth - 10)}
                y2={fieldViewport.getPixelY(35)}
            />

            {/* Bottom Field Lines */}
            <line
                x1={fieldViewport.getPixelX(0)}
                y1={fieldViewport.getPixelY(fieldHeight - 35)}
                x2={fieldViewport.getPixelX(fieldWidth)}
                y2={fieldViewport.getPixelY(fieldHeight - 35)}
            />

            <line
                x1={fieldViewport.getPixelX(10)}
                y1={fieldViewport.getPixelY(fieldHeight - 35)}
                x2={fieldViewport.getPixelX(10)}
                y2={fieldViewport.getPixelY(fieldHeight)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 10)}
                y1={fieldViewport.getPixelY(fieldHeight - 35)}
                x2={fieldViewport.getPixelX(fieldWidth - 10)}
                y2={fieldViewport.getPixelY(fieldHeight)}
            />

            {/* Center */}
            <line
                x1={fieldViewport.getPixelX(fieldWidth / 2 - 2.5)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 1.5)}
                x2={fieldViewport.getPixelX(fieldWidth / 2 + 2.5)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 1.5)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth / 2 + 2.5)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 1.5)}
                x2={fieldViewport.getPixelX(fieldWidth / 2 - 2.5)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 1.5)}
            />
            <line
                x1={fieldViewport.getPixelX(0)}
                y1={fieldViewport.getPixelY(fieldHeight / 2)}
                x2={fieldViewport.getPixelX(fieldWidth)}
                y2={fieldViewport.getPixelY(fieldHeight / 2)}
            />

            {/* Wing Lines */}
            <line
                x1={fieldViewport.getPixelX(10)}
                y1={fieldViewport.getPixelY(45)}
                x2={fieldViewport.getPixelX(10)}
                y2={fieldViewport.getPixelY(fieldHeight - 45)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 10)}
                y1={fieldViewport.getPixelY(45)}
                x2={fieldViewport.getPixelX(fieldWidth - 10)}
                y2={fieldViewport.getPixelY(fieldHeight - 45)}
            />

            {/* Substitution Area */}
            <line
                x1={fieldViewport.getPixelX(fieldWidth)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 5)}
                x2={fieldViewport.getPixelX(fieldWidth + 2)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 - 5)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth + 2)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 5)}
                x2={fieldViewport.getPixelX(fieldWidth + 2)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 5)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 + 5)}
                x2={fieldViewport.getPixelX(fieldWidth + 2)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 5)}
            />

            <text
                dx={
                    fieldViewport.flippedX
                        ? fieldViewport.getPixelX(10) - 5
                        : fieldViewport.getPixelX(fieldWidth - 10) - 5
                }
                dy={fieldViewport.flipped ? fieldViewport.getPixelY(0) - 5 : fieldViewport.getPixelY(fieldHeight) - 5}
                textAnchor="end"
                strokeWidth="0"
                fill="#aaa"
                fontSize=".8em"
            >
                LacrosseLab.com
            </text>
        </g>
    );
};

export default MensFullFieldBackdrop;
